import type { ID } from 'types';

export const paginationKeys = {
  all: (eventId: ID) => ['buyerLineItemsPagination', String(eventId)] as const,
  event: (eventId: ID) => [...paginationKeys.all(eventId), 'event'] as const,
  eventLots: (eventId: ID) => [...paginationKeys.all(eventId), 'eventLots'] as const,
  lotPage: (eventId: ID, lotId: ID, page: number, pageSize: number, search: string) =>
    [...paginationKeys.lotPages(eventId), String(lotId), page, pageSize, search] as const,
  lotPages: (eventId: ID) => [...paginationKeys.all(eventId), 'lotPage'] as const,
};
